import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let BusCheckController = {
    list: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-check/list-student-check`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-check/create`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-check/detail/${id}`,
            method: 'GET'
        }, callback)
    }
}

export default BusCheckController
